import {default_training, default_params} from './state';

/**
 * Establecer un valor para la variable trainings.
 */
export function setTrainings(state, trainings) {
    state.trainings = trainings;
}

/**
 * Establecer un valor para la variable training.
 */
export function setTraining(state, training) {

    training.workers = [];

    training.wor_worker_trainings.map((worker) => {
        training.workers.push(worker.wor_worker_id);
    });

    state.training = training;
}

/**
 * Establecer un valor para el atributo code de la variable training.
 */
export function setCodeToTraining(state, code) {
    state.training.code = code;
}

/**
 * Establecer un valor para la variable editing.
 */
export function setEditing(state, editing) {
    state.editing = editing;
}

/**
 * Establecer un valor para la variable companies.
 */
export function setCompanies(state, companies) {
    state.companies = companies;
}

/**
 * Establecer el valor por defecto de params.
 */
export function resetParams(state) {
    state.params = default_params();
    state.trainings = {data: []};
}

/**
 * Establecer el valor por defecto de area.
 */
export function resetTraining(state) {
    state.training = default_training();
}

/**
 * Establecer un valor para el atributo show la variable modal.
 */
export function setModalShow(state, show) {
    state.modal.show = show;
}

/**
 * Restablecer el valor del atributo page de la variable params.
 */
export function resetPageParams(state) {
    state.params.page = 1;
}


/**
 * Establecer un valor para la variable training_companies.
 */
export function setTrainingCompanies(state, training_companies) {
    state.training_companies = training_companies;
}

/**
 * Establecer un valor para la variable workers.
 */
export function setWorkers(state, workers) {
    state.workers = workers;
}

/**
 * Establecer un valor para el atributo show de la variable modal_upload.
 */
export function setShowToModalUpload(state, show) {
    state.upload = {file: null};
    state.modal_upload.show = show;
}
